import React from "react";

export default function ModalDestino({
  show,
  destino,
  onClose,
  onParticipar,
}) {
  if (!show || !destino) return null;

  return (
    <div
      className="modal-destino-overlay"
      onClick={onClose}
    >
      <div
        className="modal-destino"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="modal-destino-header">
          <h2>{destino.modal.titulo}</h2>

          <button
            type="button"
            onClick={onClose}
            className="modal-destino-close"
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        {/* CONTENIDO */}
        <div className="modal-destino-body">
          <p>
            {destino.modal.contenido}
          </p>
        </div>

        {/* FOOTER */}
        <div className="modal-destino-footer">

          {/* PARTICIPAR */}
          <button
            type="button"
            className="btn btn-viajes"
            onClick={onParticipar}
          >
            PARTICIPA
          </button>

        </div>
      </div>
    </div>
  );
}